export const UPDATE = "announcements/UPDATE";
export const APPEND = "announcements/APPEND";
export const UPDATE_ONE = "announcements/UPDATE_ONE";
export const DESTROY = "announcements/DESTROY";
export const LOADING = "announcements/LOADING";
